import {Component, OnInit} from '@angular/core';
import {CentreService} from "../../../../services/centre.service";
import {Router} from "@angular/router";
import {CentreOption} from "../../../../interfaces/Centres";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {FormControl} from "@angular/forms";
import {MatSelectChange} from "@angular/material/select";
import {EducationService} from "../../education.service";
import {DatePipe} from "@angular/common";
import firebase from "firebase/compat";
import Timestamp = firebase.firestore.Timestamp;
import {ViewEducationIndividualComponent} from "../view-education-individual/view-education-individual.component";
import {MatDialog} from "@angular/material/dialog";
import {AddIdividualEducationComponent} from "../add-idividual-education/add-idividual-education.component";
import {EditIndividualEducationComponent} from "../edit-individual-education/edit-individual-education.component";
import {MatSnackBar} from "@angular/material/snack-bar";
import {needConfirmation} from "../../../../confirm-dialog/confirm-dialog.decorator";
import {UserRole} from "../../../../components/rename/add-user-role/add-user-role.component";
import {LogService} from "../../../../services/log.service";
import {
    AddEducationLogComponent
} from "../../../reports/education-log-table/add-education-log/add-education-log.component";
import {LogVerifyDialogComponent} from "../../../reports/log-verify-dialog/log-verify-dialog.component";
import {EmployeeService} from "../../../../services/employee.service";
import {AngularFireDatabase} from "@angular/fire/compat/database";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {PermissionType} from "../../../../components/employee/PermissionType.enum";
import {FinancialYearService} from "../../../../services/financial-year.service";
import {
    ColDef,
    ColumnResizedEvent,
    GridApi,
    GridReadyEvent,
    ICellRendererParams,
    ITooltipParams,
    ModuleRegistry,
    ValueFormatterParams,
    ValueGetterParams,
    ClientSideRowModelModule
} from "ag-grid-community";
import {
    EducationIndividualActionsContext,
    EducationIndividualActionsRendererComponent
} from "./education-individual-actions-renderer.component";

ModuleRegistry.registerModules([ClientSideRowModelModule]);

@Component({
    selector: 'app-education-individual-table',
    templateUrl: './education-table-individual.component.html',
    styleUrls: ['./education-table-individual.component.scss']
})
export class EducationTableIndividualComponent implements OnInit, EducationIndividualActionsContext {
    mAttendance: string | null = 'Present'
    mTeacher: string | null = null
    mSession: string|null=null
    mVolunteer='All'
    start: Date | undefined
    end: Date | undefined
    centres$!: Observable<CentreOption[]>;
    userData: any
    mAllData: any[] = []
    mFilteredData: any[] = []
    rowData: any[] = []
    SelectCentre = new FormControl('')
    selectedCentre = 'All'
    permissions = JSON.parse(localStorage.getItem('permissions')!) as UserRole[]
    education = this.permissions.filter((x) => x.functionName == 'Education')
    teachers$: Observable<any[]>
    userRole = ''
  isLoading = false;  // New loading flag
    sessionTypes=['Baseline Assessment','Discharge Assessment','Intermediate Assessment','Rapport Building','Regular Study'];
    volunteers$:Observable<any>
    children: any[] = [];
    filteredChildren: any[] = [];
    selectedChild: any;
    minAge: number | null = null;
    maxAge: number | null = null;
  ageList: number[] = [];
  ageError: boolean = false;
  mHighlight: string = 'All';
  quickFilterText = '';

    // AG Grid
    private gridApi!: GridApi;
    private readonly COLUMN_STATE_KEY = 'educationIndividualTable.columnState';
    context: EducationIndividualActionsContext = this;
    defaultColDef: ColDef = {
        sortable: true,
        resizable: true,
        filter: false
    };
    colDefs: ColDef[] = [
        {
            colId: 'srNo',
            headerName: 'Sr.No.',
            valueGetter: (params: ValueGetterParams) => (params.node ? params.node.rowIndex! + 1 : ''),
            width: 90,
            minWidth: 70,
            sortable: false,
            lockVisible: true
        },
        {
            colId: 'childName',
            field: 'childName',
            headerName: 'Name',
            tooltipField: 'id',
            minWidth: 150
        },
        {
            colId: 'centreName',
            field: 'centreName',
            headerName: 'Centre',
            tooltipField: 'centreCode',
            hide: true,
            minWidth: 140
        },
        {
            colId: 'sessionDate',
            field: 'sessionDate',
            headerName: 'Date',
            comparator: (a: any, b: any) => this.toMillis(a) - this.toMillis(b),
            valueFormatter: (params: ValueFormatterParams) => this.getDate(params.value),
            minWidth: 120
        },
        {
            colId: 'startTime',
            field: 'startTime',
            headerName: 'Timing',
            hide: true,
            valueFormatter: (params: ValueFormatterParams) => params.value ? this.getTime(params.value) : '',
            minWidth: 110
        },
        {
            colId: 'sessionType',
            field: 'sessionType',
            headerName: 'Type of Session',
            tooltipField: 'sessionType',
            minWidth: 150
        },
        {
            colId: 'subject',
            field: 'subject',
            headerName: 'Subject',
            tooltipField: 'subject',
            minWidth: 120
        },
        {
            colId: 'topicsCovered',
            field: 'topicsCovered',
            headerName: 'Topic Covered',
            tooltipField: 'topicsCovered',
            minWidth: 160
        },
        {
            colId: 'remark',
            field: 'remark',
            headerName: 'Remark',
            tooltipField: 'remark',
            minWidth: 140
        },
        {
            colId: 'status',
            headerName: 'Status',
            valueGetter: (params: ValueGetterParams) => params.data?.status || 'Pending',
            tooltipValueGetter: (params: ITooltipParams) => this.getTooltip(params.data),
            minWidth: 120
        },
        {
            colId: 'submittedBy',
            field: 'submittedBy',
            headerName: 'Teacher',
            tooltipField: 'submittedBy',
            minWidth: 140
        },
        {
            colId: 'createdAt',
            field: 'createdAt',
            headerName: 'Created At',
            comparator: (a: any, b: any) => this.toMillis(a) - this.toMillis(b),
            valueFormatter: (params: ValueFormatterParams) => params.value ? this.getDateandTime(params.value) : '',
            minWidth: 160
        },
        {
            colId: 'present',
            field: 'present',
            headerName: 'Attendance',
            cellRenderer: (params: ICellRendererParams) => this.presentCellRenderer(params),
            tooltipValueGetter: (params: ITooltipParams) => params.data?.present === 'Absent' ? params.data?.absentReason : '',
            minWidth: 150
        },
        {
            colId: 'action',
            headerName: 'Action',
            cellRenderer: EducationIndividualActionsRendererComponent,
            sortable: false,
            resizable: true,
            lockVisible: true,
            pinned: 'right',
            minWidth: 240
        }
    ];

    constructor(private readonly centreService: CentreService,
                private readonly router: Router,
                private datePipe: DatePipe,
                private readonly mSnackbar: MatSnackBar,
                private readonly mDialog: MatDialog,
                private educationService: EducationService,
                private readonly _snackBar: MatSnackBar,
                private readonly matDialog: MatDialog,
                private  readonly mFirestore:AngularFirestore,
                private readonly mLogService: LogService,
                private  readonly mDatabase:AngularFireDatabase,
                private readonly mEmployeeService: EmployeeService,
                private readonly financialYearService: FinancialYearService
    ) {
        this.teachers$ = this.mEmployeeService.getTeachers()
        this.userData = JSON.parse(localStorage.getItem('userData')!)
        const sortByName = map((centres: any[]) => [...centres].sort((a, b) => (a.centreName ?? '').trim().localeCompare((b.centreName ?? '').trim())));
        if (this.userData.role == 'Centre') {
            this.centres$ = centreService.getSortedCenterListByRole(this.userData.centreCode).pipe(sortByName)
        } else if (this.userData.role != 'Centre') {
            this.centres$ = centreService.getAllCentres().pipe(sortByName)
        }
        const userData = JSON.parse(localStorage.getItem('userData')!)
        this.userRole = userData?.role
        this.volunteers$ = this.mDatabase.list('types/Volunteers').valueChanges()
    }

    clearAll() {
        // Reset date range back to the current financial year
        const fy = this.financialYearService.getCurrentFinancialYear();
        this.start = fy.startDate;
        this.end = fy.endDate;
        this.mAttendance = null
        // Reset selected centre
        this.selectedCentre = 'All';
        this.SelectCentre.setValue('');

        // Clear education data
        this.mAllData = [];
        this.mFilteredData = [];
        this.rowData = [];

      this.minAge = null;
      this.maxAge = null;
      this.mHighlight = 'All';
        // Optionally, reset any other form controls or variables here
    }
// 9960626509
  ngOnInit(): void {
    this.ageList = Array.from({ length: 28 }, (_, i) => i + 3); // 3 to 100
    // Pre-fill the date range with the current financial year (search still requires an explicit click)
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.start = fy.startDate;
    this.end = fy.endDate;
  }
  validateAgeRange() {
    if (this.minAge !== null && this.maxAge !== null) {
      this.ageError = this.minAge > this.maxAge;
    } else {
      this.ageError = false;
    }
  }
    fetchByCenter($event: MatSelectChange) {
        this.selectedCentre = $event.value
        console.log('FETCH CENTER SELECTED IN EDUCATION')
    }

  search() {
    if (this.ageError) {
      this._snackBar.open('Invalid Age Range!', '', { duration: 3000 });
      return;
    }

    this.isLoading = true;

    this.educationService.individualSearchResults(
      this.selectedCentre,
      this.start,
      this.end,
      this.mAttendance,
      this.mTeacher,
      this.mSession,
      this.mVolunteer
    ).then(res => {

      let dataWithIds = res.docs.map(doc => {
        return { id: doc.id, ...doc.data() as any };
      });

      // ✅ Highlight Filter
      if (this.mHighlight === 'Highlighted') {
        dataWithIds = dataWithIds.filter(item => item.isHighlight === true);
      }

      // ✅ Age Filter
      if (this.minAge !== null || this.maxAge !== null) {
        dataWithIds = dataWithIds.filter(child => {
          const age = child.age;
          const minCheck = this.minAge !== null ? age >= this.minAge : true;
          const maxCheck = this.maxAge !== null ? age <= this.maxAge : true;
          return minCheck && maxCheck;
        });
      }

      this.mFilteredData = dataWithIds;
      this.rowData = this.mFilteredData;
      this.isLoading = false;

    }).catch(err => {
      this.isLoading = false;
      console.error(err);
    });
  }

  getDate(date: Date): any {
        let d = (date as unknown as Timestamp).toDate()
        let datePipeString = this.datePipe.transform(d, 'dd-MMM-yyyy');
        return datePipeString
    }

    getDateandTime(date: Date): any {
        let d = (date as unknown as Timestamp).toDate()
        let datePipeString = this.datePipe.transform(d, 'dd-MMM-yyyy h:mm a ');
        return datePipeString
    }

    getTime(date: Date): any {
        let datePipeString: string | null = "NA"

        if (date != null) {
            let d = (date as unknown as Timestamp).toDate()
            datePipeString = this.datePipe.transform(d, "h:mm a")
            return datePipeString
        }
    }

    private toMillis(value: any): number {
        return value?.toDate ? value.toDate().getTime() : 0;
    }

    viewDialog(element: any) {
        this.matDialog.open(ViewEducationIndividualComponent, {
            data: element,
            width: '800%',
            autoFocus: false,
            height: '90%'
        })
      let activity={
        date:new Date().getTime(),
        section: 'Individual Education',
        action: 'View',

        description: 'Group Session View to Education by user ',
        currentIp: localStorage.getItem('currentip')!
      }
      this.mLogService.addLog(activity)
    }

    OpenIndividualEducationComponent() {
        this.matDialog.open(AddIdividualEducationComponent, {
            height: '90%',
            autoFocus: false
        })
    }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.quickFilterText = filterValue.trim().toLowerCase();
    }

    viewEdit(element: any) {
        this.matDialog.open(EditIndividualEducationComponent, {
            data: element,
            width: '800%',
            height: '90%',
            autoFocus: false

        })
      let activity = {
        date: new Date().getTime(),
        section: 'Individual Education',
        action: 'Submit',
        description: `Individual Session for  View to Education by user`,
        currentIp: localStorage.getItem('currentip')!
      }
      this.mLogService.addLog(activity)

    }

  getTooltip(element: any): string {
    const reviewRemark = element?.reviewRemark || 'No review remark';
    const reviewedBy = element?.reviewedBy || 'Unknown reviewer';

    return `${reviewRemark}\nReviewed By: ${reviewedBy}`;
  }

    @needConfirmation()
    delete(element: any) {
        this.educationService.deleteIndividualSession(element).then(() => {
            this._snackBar.open('Deleted Successfully!')._dismissAfter(3000)
          this.search();
            let activity = {
                date: new Date().getTime(),
                section: 'Individual Education',
                action: 'Delete',

                description: `Session for ${element.childCode} Deleted to Education by`,
                currentIp: localStorage.getItem('currentip')!
            }
            this.mLogService.addLog(activity)

        })
    }

    getPresent(element: any) {
        let st = 'A'
        if (element.present == "Present") st = 'P'
        return st
    }

    private presentCellRenderer(params: ICellRendererParams): HTMLElement {
        const wrapper = document.createElement('span');
        const codeSpan = document.createElement('span');
        codeSpan.textContent = this.getPresent(params.data ?? {});
        wrapper.appendChild(codeSpan);
        if (params.data?.present === 'Absent' && params.data?.absentReason) {
            const reasonSpan = document.createElement('span');
            reasonSpan.className = 'text-muted';
            reasonSpan.textContent = ` (${params.data.absentReason})`;
            wrapper.appendChild(reasonSpan);
        }
        return wrapper;
    }

    private filterWithDate(data:any,date: Date, date2: Date) {
        this.mFilteredData = data.filter((x: any) => x.sessionDate.toDate() >= date && x.sessionDate.toDate() <= date2)
    }

    changeStatus(element: any) {
        if (this.userRole == "Centre Manager" || "Developer" || "Developer") {
            this.mDialog.open(LogVerifyDialogComponent, {
                data: {
                    ref: `educationTest/${element.id}`,
                    id:element.id,
                    status: element.status || 'Pending',
                  reviewRemark:element.reviewRemark||''
                }
            }).afterClosed().subscribe(res=>{
               let i = this.rowData.findIndex(x=>x.id==res.id)
               if (i > -1) {
                   this.rowData[i].status = res.status
                   this.rowData[i].reviewRemark = res.reviewRemark
                   this.rowData = [...this.rowData]
               }
            })
        } else {
            this.mSnackbar.open('Only for Centre Manager', "", {
                panelClass: 'error',
                duration: 3000
            })
        }
    }

  filterData() {
    this.mFilteredData = this.mAllData.filter(x =>
      (this.mAttendance === 'All' || this.mAttendance === null || x.present === this.mAttendance) &&
      (this.mTeacher === 'All' || this.mTeacher === null || x.submittedBy === this.mTeacher) &&
      (this.mSession === 'All' || this.mSession === null || x.sessionType === this.mSession)
    );

    console.log('after filtering: attendance', this.mAttendance);
    console.log('after filtering: teacher', this.mTeacher);
    console.log('after filtering: session', this.mSession);
    this.rowData = this.mFilteredData;
  }

  downloadExcel() {
    const tableData: any[] = [];
    if (this.gridApi) {
      this.gridApi.forEachNodeAfterFilterAndSort(node => {
        if (node.data) tableData.push(node.data);
      });
    } else {
      tableData.push(...this.rowData);
    }

    if (!tableData || tableData.length === 0) {
      alert('No data available to download');
      return;
    }

    let excelContent = `
    <table border="1">
      <tr>
        <th>Sr.No</th>
        <th>Name</th>
        <th>Centre</th>
        <th>Session Date</th>
        <th>Session Type</th>
        <th>Subject</th>
        <th>Topics Covered</th>
        <th>Attendance</th>
        <th>Absent Reason</th>
<!--        <th>Volunteer</th>-->
        <th>Remark</th>
        <th>Teacher</th>
        <th>Created At</th>
        <th>Status</th>
      </tr>
  `;

    tableData.forEach((x: any, index: number) => {
      excelContent += `
      <tr>
        <td>${index + 1}</td>
        <td>${x.childName ?? '-'}</td>
        <td>${x.centreName ?? '-'}</td>
        <td>${x.sessionDate ? this.getDate(x.sessionDate) : '-'}</td>
        <td>${x.sessionType ?? '-'}</td>
        <td>${x.subject ?? '-'}</td>
        <td>${x.topicsCovered ?? '-'}</td>
        <td>${this.getPresent(x)}</td>
        <td>${x.present === 'Absent' ? (x.absentReason ?? '-') : '-'}</td>
<!--        <td>${x.volunteerName ?? '-'}</td>-->
        <td>${x.remark ?? '-'}</td>
        <td>${x.submittedBy ?? '-'}</td>
        <td>${
        x.createdAt
          ? this.getDateandTime(x.createdAt)
          : '-'
      }</td>
        <td>${x.status ?? 'Pending'}</td>
      </tr>
    `;
    });

    excelContent += `</table>`;

    const blob = new Blob(
      ['﻿' + excelContent],
      { type: 'application/vnd.ms-excel;charset=utf-8;' }
    );

    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `Education_Individual_Sessions_${Date.now()}.xls`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }




  /**
   * Toggle the highlight status of a counseling session.
   * Updates the highlight field in Firestore and updates the local element.
   * @param element - The session element to toggle highlight for
   */
  toggleHighlight(element: any) {
    // Optimistically update the UI

    // Update in Firestore
    this.educationService.toggleIndividualSessionHighlight(element)
      .then(() => {
        console.log('Highlight toggled successfully');
        // Log the action
        let activity = {
          date: new Date().getTime(),
          section: 'Individual Counseling',
          action: 'Toggle Highlight',
          description: `Session for ${element.childCode} ${element.isHighlight ? 'highlighted' : 'unhighlighted'} by user`,
          currentIp: localStorage.getItem('currentip')!
        };
        this.mLogService.addLog(activity);
      })
      .catch(err => {
        console.error('Error toggling highlight:', err);
        // Revert the optimistic update on error
        element.isHighlight = !element.isHighlight;
      });
    element.isHighlight = !element.isHighlight;

  }
  protected readonly PermissionType = PermissionType;

    searchChild(event: MatSelectChange) {
        this.rowData = this.mFilteredData.filter((x: any) => x.childCode == event.value)
    }

    displayChild(child: any): string {
        return child ? `${child.childName} (${child.childCode})` : '';
    }

    // AG Grid lifecycle / column customization -----------------------------

    onGridReady(params: GridReadyEvent) {
        this.gridApi = params.api;
        const saved = localStorage.getItem(this.COLUMN_STATE_KEY);
        if (saved) {
            try {
                this.gridApi.applyColumnState({state: JSON.parse(saved), applyOrder: true});
            } catch (e) {
                console.error('Failed to restore column state', e);
            }
        }
    }

    persistColumnState = () => {
        if (!this.gridApi) return;
        const state = this.gridApi.getColumnState();
        localStorage.setItem(this.COLUMN_STATE_KEY, JSON.stringify(state));
    }

    onColumnResized(event: ColumnResizedEvent) {
        if (event.finished) {
            this.persistColumnState();
        }
    }

    get toggleableColumns(): ColDef[] {
        return this.colDefs.filter(c => !c.lockVisible);
    }

    isColumnVisible(colId: string): boolean {
        if (!this.gridApi) return true;
        const col = this.gridApi.getColumn(colId);
        return col ? col.isVisible() : true;
    }

    toggleColumnVisibility(colId: string, visible: boolean) {
        this.gridApi?.setColumnsVisible([colId], visible);
        this.persistColumnState();
    }

    resetColumns() {
        this.gridApi?.resetColumnState();
        localStorage.removeItem(this.COLUMN_STATE_KEY);
    }
}
